import Route from '@ember/routing/route';

export default class ClientPolicy extends Route {
  // normal class body definition here
}
